import { Card } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RoutePaths } from '../routes/AppRoutes';
import TopAppBar from '../common/components/TopAppBar';
import ContextNavigation from './ContextNavigation';

export default function NavigationContexts(): React.JSX.Element {
  const { t } = useTranslation(['common']);

  return (
    <>
      <TopAppBar
        configuration="small"
        backTo={RoutePaths.ROOT}
        title={t('common:switch_company')}
      />
      <Card sx={{ mx: 2, my: 0.5, p: 1, borderRadius: 3 }}>
        <ContextNavigation showCurrent />
      </Card>
    </>
  );
}
